import { Button, ClickAwayListener, IconButton } from "@mui/material";
import React, { useEffect, useRef } from "react";
import Editor from "../../../Editor/Editor";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { createRoot } from "react-dom/client";
import { CreateBackgroundForModal, resumeRequest, tokenProcessingTest } from "../../../TokenProcessing/TokenProcessing";
import DialogSetObjText from "../../Module/Dialogs/DialogSetObjText";
import DialogCreateObj from "../../Module/Dialogs/DialogCreateObj";
import ModalWindow from "../../Module/ModalWindow";
import { getDefaultMenu, getEditorListFormat, getStyleWindow, setColor } from "../../Tools/Tools";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import CircleIcon from "@mui/icons-material/Circle";
import CheckBoxMultiCheck from "./CheckBoxMultiCheck";
import LoadingMask from "../../NotWorkArea(Side&Head)/LoadingMask";
import HistoryIcon from "@mui/icons-material/History";
import TextAreaWithButtons from "../../Module/Dialogs/Components/TextAreaWithButtons";
import ContextMenu from "../../NotWorkArea(Side&Head)/ContextMenu";
import DialogHistory from "../../Module/Dialogs/DialogHistory";
import Scrollbars from "react-custom-scrollbars-2";
import ConditionButton from "./ParamsComponents/ConditionButton";
import DialogSaveSample from "../../Module/Dialogs/DialogSaveSample";
import { HandleSamples } from "../../Tools/Requests";
import sectionsStyles from "../SectionsCss/sectionsStyles.module.css";
import clsx from "clsx";
import { Prefixes } from "../../Tools/ProjectX";
import smetaAxios from "../../../SmetaAxios";
import { smetaModals } from "../../Tools/modalManager";

// опции стилей текста названия параметра
const FontStyle_Bold = 1;
const FontStyle_Italic = 2;
const FontStyle_Underline = 4;
const FontStyle_StrikeOut = 8;

// опции параметров
const ParamSetOption_Disabled = 1; // +
const ParamSetOption_InConfig = 2; // -
const ParamSetOption_Calculated = 4; // -
const ParamSetOption_Detalization = 8; // -
const ParamSetOption_Markable = 16; // -
const ParamSetOption_Collapsed = 32; // +
const ParamSetOption_Reference = 64; // -
const ParamSetOption_RedNegative = 128; // -
const ParamSetOption_Inspector = 256; // -
const ParamSetOption_Grid = 512; // -
const ParamSetOption_Sortable = 1024; // -
const ParamSetOption_Filterable = 2048; // -
const ParamSetOption_Override = 4096; // -
const ParamSetOption_Hidden = 8192; // +
const ParamSetOption_History = 16384; // +-
const ParamSetOption_CanGroup = 32768; // -
const ParamSetOption_Fixed = 65536; // -
const ParamSetOption_NotEdit = 131072; // -

// функции для сплиттера с возможностью изменения размеров полей
var resize = {};

// функция включения live изменения размеров
function onMouseDown(ev) {
  const record = ev.target.closest("TR");
  const table = record.parentElement;
  const el = record.querySelector(".td-name");
  const elements = table.querySelectorAll(".td-name");
  resize.resizeMode = true;
  resize.target = ev.target;
  resize.cells = elements;
  resize.cell = el;
}
// функция установки размеров после изменения
function onMouseUp(ev, width) {
  if (resize.size !== undefined) {
    if (resize.ctrlKey) {
      resize = {};
      return;
    }
    width.current = resize.size;
  }
  resize = {};
}

// функция live изменения размеров
function onMouseMove(ev) {
  if (resize.resizeMode) {
    const x = ev.clientX;
    const targetWidth = resize.target.clientWidth;
    const targetX = resize.target.getBoundingClientRect().x;

    if (ev.ctrlKey) {
      resize.ctrlKey = true;
      let size = x - targetWidth - targetX;
      size =
        (resize.cell.clientWidth / resize.cell.parentElement.clientWidth) * 100 +
        (size / resize.cell.parentElement.clientWidth) * 100;
      if (size < 30) size = 30;
      if (size > 70) size = 70;
      resize.cell.style.width = `${size}%`;
      return;
    }
    resize.cells.forEach((el) => {
      let size = x - targetWidth - targetX;
      if (el.style.clientWidth === 0) return;
      size = (el.clientWidth / el.parentElement.clientWidth) * 100 + (size / el.parentElement.clientWidth) * 100;
      if (size < 30) size = 30;
      if (size > 70) size = 70;
      resize.size = size || resize.size;
      el.style.width = `${resize.size}%`;
    });
  }
}

// функция получения параметров
function getParams(module, command, groupId, needRefresh, Path, SectionID, prm, reportID) {
  const params = {
    Path: Path,
    GroupID: groupId,
    NeedRefresh: needRefresh,
    SectionID: SectionID,
    prm: prm,
    ReportID: reportID,
  };
  const config = {
    prefix: module,
    method: "GET",
    url: command,
    params,
  };
  return smetaAxios(config);
}

// функция расчета отступов для параметров в завизимости от уровня вложенности
function getPadding(items, item, index) {
  let padding = 15;
  const level = item.Level ? item.Level : 0;

  if (items.length - 1 > index && level < items[index + 1].Level && checkNextItemsVisible(items, item, index)) {
    padding -= 15;
  }
  if (item.Options & ParamSetOption_Markable) {
    padding -= 15;
  }
  if (item.Level) {
    padding += item.Level * 15;
  }
  return padding;
}

// запрос следующего или предыдущего состояния параметров
async function getHistory(data) {
  const params = {
    Path: data.Path,
    History: data.history,
  };
  const config = {
    prefix: Prefixes.progs,
    method: "GET",
    url: "GetParamDialog",
    params,
  };

  return smetaAxios(config);
}

// функция установки стилей для текста названия параметра
function getStyleName(item) {
  return {
    color: item.NameColor ? setColor(item.NameColor) : "",
    display: "flex",
    flex: "1 1 0",
    fontWeight: item.NameStyle & FontStyle_Bold ? "bold" : "",
    fontStyle: item.NameStyle & FontStyle_Italic ? "italic" : "",
    textDecoration:
      item.NameStyle & FontStyle_Underline ? "underline" : item.NameStyle & FontStyle_StrikeOut ? "line-through" : "",
  };
}

// функция для установки стилей для текста значения параметра
function getStyleColor(item) {
  // костыль
  // понять как кодируется этот цвет
  // if (true) {
  //   return "#aaaaaa";
  // }

  if (item.TextColor !== undefined) {
    return setColor(item.TextColor);
  }

  return "";
}

function getStyleText(item) {
  const style = {};
  if (item.TextStyle !== undefined) {
    style.fontWeight = item.TextStyle & FontStyle_Bold ? "bold" : "";
    style.fontStyle = item.TextStyle & FontStyle_Italic ? "italic" : "";
    style.textDecoration =
      item.TextStyle & FontStyle_Underline ? "underline" : item.TextStyle & FontStyle_StrikeOut ? "line-through" : "";
    style.fontSize = "0.75rem";
  }
  return style;
}

function checkNextItemsVisible(items, item, index) {
  let result = false;
  const level = item.Level ? Number(item.Level) : 0;
  for (let i = index + 1; i < items.length; i++) {
    if (level + 1 !== Number(items[i].Level)) return result;
    if (items[i].Options & 1) {
      result = false;
    } else {
      return true;
    }
  }
  return result;
}

// На вход необходимо передать:

// Обязательно:
// Module - Модуль используемый для запросов параметров
// reqCommand - команда используемая для запросов параметров
// data - объект параметров с данными

// По необходимости:
// Path - Путь используемый для запросов параметров(если есть)
// GroupID - ID элемента для которого используются параметры, для запроса параметров под конкретный элемент(по необходимости)
// SectionID - ID секции для которой используются парамеры(по необходимости)
// prm - данные для запроса параметров (по необходимости)
// reportID - ID отчета для запроса параметров (по необходимости)

// Настройки разметки:
// NoHistory - значение true отключает кнопки истории
// NoTitle - значение true отключает заголовок параметров
export default function Params({ smetaModalId = "", ...props }) {
  // переменная для хранения данных об истории
  const [history, setHistory] = React.useState();
  // полные данные параметров
  const [paramsData, setParamData] = React.useState();
  // данные записей
  const [paramsItems, setParamsItems] = React.useState();
  // записи для отрисовки
  const [paramsJsx, setParamsJsx] = React.useState();

  const [paramsButtons, setParamsButtons] = React.useState([]);

  const [paramsButtonsJsx, setParamsButtonsJsx] = React.useState([]);

  const [title, setTitle] = React.useState("");

  const [filter, setFilter] = React.useState(props.defaultFilter);

  const [loading, setLoading] = React.useState(false);

  const changes = useRef({});

  // размер 1-ой колонки для контроля
  const width = React.useRef(35);

  const [buttonBlockWidth, setbuttonBlockWidth] = React.useState(0);
  // переменная для хранения элемента с редактором
  const editor = React.useRef();

  // карта с функциями редактирования отрисованных редакторов
  const [editionMap, setEditionMap] = React.useState();

  // хук для получения функций редактирования и записи их в карту выше
  const [getEdition, setGetEdition] = React.useState();

  // переменная для динамической отрисовки редактора, контролирует отрисвку по нажатой клавише мыши
  const mouseDown = React.useRef(null);

  // ссылка на контейнер параметров
  const paramsBox = React.useRef();

  const needOpenEditor = React.useRef();

  // Первичная установка объекта параметров
  React.useEffect(() => {
    // получение данных если они не были переданны из вне
    if (props.data) {
      setParamData(props.data);
    }

    paramsBox.current.update = (data) => {
      // setParamsJsx(null);
      // setEditorMap(new Map());
      // setEditionMap(new Map());

      deleteEditor(editor);
      setParamData(data);
    };

    paramsBox.current.focus = () => {
      if (editor.current && !editor.current.classList.contains(clsx(sectionsStyles.hiddenBlock))) {
        const input = editor.current.querySelector("input[type=text]");
        if (input) {
          input.focus();
          // проверка на readOnly
          const record = editor.current.closest("TR");
          if (record && record.dataset.editstyle & 64) return;
          input.select();
        }
      } else {
        const record = paramsBox.current.querySelector("TR");
        if (record) record.click();
      }
    };

    // инициализация карт хранения
    setEditionMap(new Map());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // при изменении данных снаружи они обновляются
  React.useEffect(() => {
    if (props.data) {
      // setEditorMap(new Map());
      // setEditionMap(new Map());
      // setParamsJsx(null);
      deleteEditor(editor);
      setParamData(props.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data]);

  React.useEffect(() => {
    if (props.fixHistory && props.setFixHistory) {
      setHistory(props.fixHistory);
      props.setFixHistory(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.fixHistory]);

  React.useEffect(() => {
    if (props.currentPage !== undefined && paramsData) {
      setParamsItems(
        paramsData.Items.filter((item) => {
          if (props.currentPage === 0) {
            return item.PageIndex === undefined || Number(item.PageIndex) === 0;
          }

          return Number(item.PageIndex) === props.currentPage;
        }),
      );

      const match = props.pageTitles[props.currentPage].Name.match(/[^\\]+$/);
      if (match) {
        setTitle(match[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.currentPage]);

  React.useEffect(() => {
    // обновление параметров при изменении общих данных
    if (paramsData) {
      // скрытие текущего редактора если он был открыт
      if (editor.current) {
        deleteEditor(editor.current);
      }

      // обновление массива записей
      if (props.currentPage !== undefined && paramsData) {
        setParamsItems([
          ...paramsData.Items.filter((item) => {
            if (props.currentPage === 0) {
              return item.PageIndex === undefined || Number(item.PageIndex) === 0;
            }

            return Number(item.PageIndex) === props.currentPage;
          }),
        ]);
        const match = props.pageTitles[props.currentPage].Name.match(/[^\\]+$/);
        if (match) {
          setTitle(match[0]);
        }
      } else {
        setParamsItems([...paramsData.Items]);

        if (paramsData.Title) {
          // любой символ с конца кроме "\"
          const match = paramsData.Title.match(/[^\\]+$/);
          if (match) {
            setTitle(match[0]);
          }
        }
      }

      if (filter === undefined) {
        setFilter(paramsData.Filter ? true : false);
      }
      // обновление данных истории
      setHistory(paramsData.History);

      if (paramsData?.Buttons?.items?.length) {
        const result = [];
        paramsData.Buttons.items.forEach((item, index) => {
          item.Caption && item.Hidden !== "1" && result.push({ ...item, id: index });
        });
        setParamsButtons([...result]);
      }

      paramsBox.current.dialogButtonClick = (id, ProgID, callBack) => {
        dialogButtonClick({ currentTarget: { id } }, paramsData.Path, ProgID, callBack);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsData]);

  React.useEffect(() => {
    // обновление отрисованных записей
    if (paramsItems) {
      setParamsJsx(getJsxParams(paramsItems, width));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsItems]);

  useEffect(() => {
    if (paramsData?.SelectedIndex) {
      const tr = paramsBox.current?.querySelector(`TR[param-index="${paramsData?.SelectedIndex}"]`);
      tr?.click();
    }
  }, [paramsJsx]);

  React.useEffect(() => {
    if (paramsButtons.length === 0) return;
    setParamsButtonsJsx(getParamsButtons(paramsButtons));
  }, [paramsButtons]);

  // заполнение карты с функциями редактирования при отрисовке нового редактора
  React.useEffect(() => {
    if (getEdition) {
      editionMap.set(getEdition.id, {
        setValue: getEdition.setValue,
        setInputValue: getEdition.setInputValue,
        value: getEdition.value,
        inputValue: getEdition.inputValue,
        setSelection: getEdition.setSelection,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getEdition]);

  // разворачивание записей при первой отрисовке, если они должны быть развернуты
  React.useLayoutEffect(() => {
    if (paramsJsx) {
      paramsBox.current.querySelectorAll("#expandButtonParams").forEach((el) => {
        if ((Number(el.dataset.collapsed) & ParamSetOption_Collapsed) !== ParamSetOption_Collapsed) {
          el.closest("TR").dataset.collapsed = "1";
          expandRec({ target: el });
        }
      });

      if (needOpenEditor.current) {
        setTimeout(() => {
          if (editor.current) {
            needOpenEditor.current = editor.current.closest("TR");
            renderEditor({ target: needOpenEditor.current });
            needOpenEditor.current = undefined;
            return;
          }
          renderEditor({ target: needOpenEditor.current });
          needOpenEditor.current = undefined;
        }, 1);
      }
    }
  }, [paramsJsx]);

  // функция для получения кнопки разворачивания записей
  function getExpandOrMarkButton(items, item, index) {
    const level = item.Level ? item.Level : 0;
    if (items.length - 1 > index && level < items[index + 1].Level && checkNextItemsVisible(items, item, index)) {
      return (
        <IconButton
          id="expandButtonParams"
          data-collapsed={item.Options}
          name="expandButton"
          onClick={async (ev) => {
            const record = ev.target.closest("tr");
            await collapseReq(
              record.id.split("_")[1],
              props.Path ? props.Path : paramsData.Path,
              record.dataset.collapsed === "1" ? "0" : "1",
            );
            expandRec(ev);
          }}
          className={clsx(
            sectionsStyles.paramsExpandButton,
            Number(item.Options) & ParamSetOption_Collapsed && sectionsStyles.paramsExpandButtonRotate,
          )}
        >
          <ExpandMoreIcon style={{ height: "15px", width: "15px" }} />
        </IconButton>
      );
    }

    if (Number(item.Options) & ParamSetOption_Markable) {
      return (
        <IconButton
          id="markButtonParams"
          title="Маркировать"
          data-enabled="false"
          onClick={async (ev) => {
            const bttn = ev.target.closest("#markButtonParams");
            const icon = bttn.querySelector("path");
            if (bttn.dataset.enabled === "true") {
              icon.style.color = "#cccccc";
              bttn.dataset.enabled = "false";
              bttn.title = "Маркировать";
            } else {
              icon.style.color = "#006cbf";
              bttn.dataset.enabled = "true";
              bttn.title = "Снять маркировку";
            }
            const record = ev.target.closest("tr");
            record.dataset.marked = bttn.dataset.enabled === "true" ? "1" : "0";

            await getSetParamRequest("marker")({
              Path: props.Path ? props.Path : paramsData.Path,
              ID: record.id.split("_")[1],
              GroupID: paramsData.GroupID,
              Marked: record.dataset.marked,
            });
          }}
          className={clsx(sectionsStyles.paramsMarkerButton)}
        >
          <CircleIcon style={{ height: "5px", width: "5px", color: "#cccccc" }} />
        </IconButton>
      );
    }
  }

  // запрос сворачивания и разворачивания записи для сервера
  async function collapseReq(id, Path, collapsed) {
    const params = {
      Path: Path,
      ID: id,
      Collapsed: collapsed,
    };
    const config = {
      prefix: Prefixes.progs,
      method: "GET",
      url: "ParamCollapsed",
      params,
    };

    return smetaAxios(config);
  }

  // Функция скрытия и отображения записей при клике на кнопку expandButton
  function expandRec(ev) {
    // получение кнопки на текущей записи
    let button = ev.target.closest("BUTTON");
    // получение текущей записи
    let record = ev.target.closest("TR");
    const tdName = record.querySelector(".td-name");
    // получение уровня вложенности
    let level = record.dataset.level;
    // получение следующей записи
    let nextRec = record.nextElementSibling;

    // получение id родительской записи
    // const parentID = record.id.split("_")[1];

    //выражение для проверки состояния развернутости записи
    const condition = record.dataset.collapsed === "1";
    // сокрытие или раскрытие всех дочерних записей у родительской
    // цикл работает до тех пор, пока уровень вложенности следующей записи больше чем уровень первоначальной записи
    while (nextRec && nextRec.dataset.level > level) {
      // проверка привязки к родительской записи
      // if (nextRec.dataset.parentid === parentID) {
      // проверка на наличие вложенных записей
      const nextButton = nextRec.querySelector("button[name=expandButton]");
      // если вложенные записи были развернуты то они свернутся при сворачивании записей родителя
      if (nextButton && nextRec.dataset.collapsed === "0") {
        nextRec.dataset.collapsed = "1";
        nextButton.classList.add(clsx(sectionsStyles.paramsExpandButtonRotate));
      }
      // сокрытие или раскрытие записей в зависимости от условия
      if (condition) {
        nextRec.classList.remove(clsx(sectionsStyles.hiddenBlock));
        const td = nextRec.querySelector(".td-name");
        if (td && tdName) td.style.width = tdName.style.width;
      } else {
        nextRec.classList.add(clsx(sectionsStyles.hiddenBlock));
      }
      // проверка привязки к родительской записи
      if (
        nextRec.dataset.level !== `${Number(level) + 1}` ||
        Number(nextRec.dataset.options) & ParamSetOption_Disabled
        // Number(nextRec.dataset.options) & ParamSetOption_Hidden
      ) {
        nextRec.classList.add(clsx(sectionsStyles.hiddenBlock));
      }
      nextRec = nextRec.nextElementSibling;
    }

    // поворот кнопки при сворачивании
    if (condition) button.classList.remove(clsx(sectionsStyles.paramsExpandButtonRotate));
    else button.classList.add(clsx(sectionsStyles.paramsExpandButtonRotate));
    record.dataset.collapsed = condition ? "0" : "1";
  }

  function onCloseSelection(data) {
    const editval =
      data.record.dataset.editval !== undefined
        ? data.record.dataset.editval
        : data.record.dataset.value !== undefined
        ? data.record.dataset.value
        : "";
    const value =
      data.record.dataset.value !== undefined
        ? data.record.dataset.value
        : data.record.dataset.editval !== undefined
        ? data.record.dataset.editval
        : "";

    data.setValue({
      label: editval,
      id: data.record.dataset.objref !== undefined ? data.record.dataset.objref : "",
    });
    data.setInputValue(editval);
    data.record.querySelector('[textvalue="true"]').innerText = value;
  }

  // функция для выбора запроса
  // возвращает функицю в которую нужно передать data
  // пример: getSetParamRequest(selector)({data})
  function getSetParamRequest(selector) {
    const requests = {
      marker: (data) => {
        const params = {
          Path: data.Path,
          ID: data.ID,
          GroupID: data.GroupID || "0",
          Marked: data.Marked,
        };
        const config = {
          prefix: Prefixes.progs,
          method: "GET",
          url: "SetParamProperty",
          params,
        };
        return smetaAxios(config);
      },
      custom: (data) => {
        return props.onSetParam(data);
      },
      customList: (data) => {
        return props.onEditList(data);
      },
      default: (data) => {
        const params = {
          Path: data.Path,
          ID: data.ID,
          GroupID: data.GroupID || "0",
          ObjRef: data.ObjRef || "0",
          CheckState: data.CheckState,
          Value: data.Value,
          Condition: data.Condition,
          Selection: (data.MultiSelect || data.Selection) && data.Selection,
          ListIndex: data.ListIndex || undefined,
          TextChanged: data.TextChanged,
          WSM: "1",
        };
        const config = {
          prefix: Prefixes.progs,
          method: "GET",
          url: "SetParamProperty",
          params,
          loadMask: false,
        };
        return smetaAxios(config);
      },
    };
    return selector && requests[selector] ? requests[selector] : requests.default;
  }

  const getSelector = (data) => {
    if (data.listClick && props.onEditList) {
      return "customList";
    }
    if (props.onSetParam) {
      return "custom";
    }
    return "default";
  };

  // функция на редактирование параметров
  async function onEdit(data) {
    needOpenEditor.current = data.record;

    const textValueDiv = data.record.querySelector('[textvalue="true"]');
    // если нет изменений значения или id, или состояния чекбокса, то устанавливается старое
    if (data.value === undefined) data.value = data.record.dataset.value;
    if (data.tag === undefined) data.tag = data.record.dataset.objref;
    if (data.CheckState === undefined) {
      data.CheckState = data.record.dataset.checkstate;
    }
    if (data.Condition === undefined) {
      data.Condition = data.record.dataset.condition;
    }

    mouseDown.current = false;
    if (data.value !== undefined) textValueDiv.innerText = data.value;
    setLoading(true);
    // получение запроса для редактирования и ответа
    const res = await getSetParamRequest(getSelector(data))({
      Path: props.Path ? props.Path : paramsData.Path,
      ID: data.record.id.split("_")[1],
      GroupID: paramsData.GroupID,
      ObjRef: data.tag,
      Value: data.value,
      Condition: data.Condition,
      CheckState: data.CheckState,
      MultiSelect: data.multiselect,
      Selection: data.selection,
      ListIndex: data.listindex,
      TextChanged: data.textchanged !== undefined ? data.textchanged : "1",
      Module: data.record.dataset.module,
      ObjType: data.record.dataset.datatype,
    });

    setLoading(false);

    props.onEditParams?.(res, data);
    // Установка значений параметров
    settingValues(res, data);

    changes.current[data.record.dataset.fieldname || data.record.dataset.shortname] = {
      ...data.record.dataset,
      tag: data.tag,
      value: data.value,
    };
    props?.setChanges?.({ ...changes.current });
  }

  // функция установки локальных значений параметров
  function settingValues(res, data) {
    // при наличии Токена установка идет через токен процесс
    if (res) {
      if (res.Token) {
        tokenProcessingTest(res, {
          func: (val) => {
            settingValues(val, data);
          },
        });
        return;
      }

      // открытие окна с выбором элементов при неточном вводе в ручную
      if (res.Selection && res.Selection.length && !data.noSelection) {
        if (res.Selection.length === 1) {
          onEdit({
            ...data,
            value: res.Selection[0].text,
            tag: res.Selection[0].id,
            noSelection: true,
          });
          return;
        }

        smetaModals.open(
          <DialogSetObjText
            list={res.Selection}
            onEdit={onEdit}
            record={data.record}
            CheckState={data.CheckState}
            onClose={() => onCloseSelection(data)}
            func={(res) => {
              needRefreshParams(res);
            }}
          />,
          {
            Title: "Выберите элемент из списка",
            style: getStyleWindow(),
            hiddenButton: true,
            blockMaximize: true,
            onClose: () => onCloseSelection(data),
          },
        );
        return;
      }

      // открытие окна с созданием нового объекта
      if (res.CreateNew) {
        smetaModals.open(
          <DialogCreateObj
            onEdit={onEdit}
            inputNameObj={res.CreateNew.Text}
            spanText={res.CreateNew.Label}
            CLSID={res.CreateNew.CLSID}
            ObjType={data.datatype}
            Module={data.type}
            groups={res.CreateNew.Groups}
            record={data.record}
            CheckState={data.CheckState}
          />,
          {
            Title: "Создать новый объект",
            style: getStyleWindow(`${res.CreateNew.CLSID}${res.CreateNew.Groups ? "Group" : ""}`),
            hiddenButton: true,
            blockMaximize: true,
            blockSaveLocation: true,
          },
        );
        return;
      }

      if (!res.Values) return;

      // обновление значений из ответа
      res.Values.forEach((item) => {
        // редактируемая запись
        const rec = data.record;
        // контейнер со значением параметра
        const textValueDiv = rec.querySelector('[textvalue="true"]');

        let inpValue = item.EditVal ? item.EditVal : item.Value !== undefined ? item.Value : "";

        let txtFldValue = item.Value !== undefined ? item.Value : item.EditVal !== undefined ? item.EditVal : "";

        const index = rec.id.split("_")[2];
        const paramitem = paramsData.Items[index];
        paramitem.EditVal = inpValue;
        paramitem.Value = item.Value ? item.Value : "";
        paramitem.ObjRef = item.ObjRef ? item.ObjRef : "0";
        if (item.CheckState) {
          paramitem.CheckState = item.CheckState;
        }
        paramitem.Selection = item.Selection;

        // заполнение записи данными
        rec.dataset.editval = inpValue;
        rec.dataset.value = item.Value ? item.Value : "";
        rec.dataset.objref = item.ObjRef ? item.ObjRef : "0";

        if (item.CheckState !== undefined) {
          if (data.setStateCheckBox) data.setStateCheckBox(item.CheckState);
          rec.dataset.checkstate = item.CheckState;
        }

        textValueDiv.innerText = txtFldValue;

        textValueDiv.style.color =
          textValueDiv.innerText < 0 && rec.dataset.options & ParamSetOption_RedNegative ? "red" : getStyleColor(item);

        rec.dataset.selection = item.Selection;

        // обновление значения в редакторе
        if (editor.current) {
          const edition = editionMap.get(rec.id);
          if (edition) {
            if (data.fixVal) {
              inpValue = data.fixVal(inpValue);
            }
            edition.setValue({
              label: inpValue,
              id: item.ObjRef ? item.ObjRef : "0",
            });
            edition.setInputValue(inpValue);
            if (item.Selection !== undefined) {
              edition.setSelection(item.Selection);
            } else {
              edition.setSelection("");
            }
          }
        }
      });

      setParamData({ ...paramsData });
      // при необходимости обновить все записи перерисуются (запрос с данными по необходимости)
      needRefreshParams(res);
    }
  }

  async function needRefreshParams(res) {
    if (res.NeedRefresh === "1" && !props.notRefresh) {
      if (props.getRefreshParams) {
        const json = await props.getRefreshParams(props, paramsData);
        deleteEditor(editor);
        setParamData(json);
        return;
      }
      if (props.Module === "documents") {
        const params = {
          DocCfgID: props.id,
          SectionID: props.SectionID,
          GridState: "1",
        };
        const config = {
          prefix: Prefixes.doc,
          method: "GET",
          url: "GetDocumentLayout",
          params,
        };
        smetaAxios(config).then((res) => {
          deleteEditor(editor);
          setParamData(res.Params);
        });
        return;
      }
      setLoading(true);
      getParams(
        props.Module,
        props.reqCommand,
        props.GroupID,
        "1",
        paramsData.Path,
        props.SectionID,
        props.prm,
        props.reportID,
      ).then((res) => {
        deleteEditor(editor);
        setParamData(res);
        setLoading(false);
      });
    }
  }

  // функция открытия модального окна в редакторе
  async function onEditButtonClick(data) {
    if (data.subData.props.editParam !== undefined) {
      const params = {
        ID: data.subData.props.record.id.split("_")[1],
        Path: props.Path || paramsData.Path,
        WSM: "1",
      };
      const config = {
        prefix: Prefixes.progs,
        method: "GET",
        url: "EditParamProperty",
        params,
      };
      const json = await smetaAxios(config);

      json?.Token &&
        tokenProcessingTest(json, {
          ...data.subData,
          func: (res) => {
            needRefreshParams(res);
          },
        });
      return;
    }

    if (data.json) {
      tokenProcessingTest(data.json, data.subData);
      return;
    }

    if (data.datatype <= 12 && data.datatype > 0) {
      CreateBackgroundForModal(
        <ModalWindow Title={data.subData.props.record.dataset.name} style={getStyleWindow()} hiddenButton={true}>
          <TextAreaWithButtons
            props={{
              ...data.subData.props,
              setValue: data.setValue,
              setInputValue: data.setInputValue,
              Title: data.subData.props.record.dataset.name,
            }}
          />
        </ModalWindow>,
      );
      return;
    }
  }

  // функция значений для выпадающего списка в редакторе
  async function onDropDownList(data, checklist) {
    let json;
    if (props.onDropDownList) {
      json = await props.onDropDownList({ module: data.record.dataset.module, datatype: data.record.dataset.datatype });
    } else {
      const params = {
        Path: props.Path || paramsData.Path,
        ID: data.record.id.split("_")[1],
      };
      const config = {
        prefix: Prefixes.progs,
        method: "GET",
        url: "GetParamValues",
        params,
      };
      json = await smetaAxios(config);
    }

    if (json && json.Items) {
      return getEditorListFormat(json.Items, { checklist });
    }
  }

  // функция для рендера или сокрытия/раскрытия редактора
  function renderEditor(ev) {
    if (!ev.target || props.noEdit) return;
    // выбранная запись
    const record = ev.target.closest("TR");

    if (!record) return;
    // проверка на отображение редактора
    if (!record.querySelector('div[editor="true"]').classList.contains(clsx(sectionsStyles.hiddenBlock))) return;

    record.style.backgroundColor = "whitesmoke";

    // контейнер для редактора
    const editorDiv = record.querySelector('[editor="true"]');
    // контейнер для текста параметров
    const textValueDiv = record.querySelector('[textvalue="true"]');
    // удаление(скрытие) другого отрисованного редактора
    if (editor.current && editor.current !== editorDiv) {
      deleteEditor(editor.current);
    }
    const editRoot = editorDiv.root || createRoot(editorDiv);
    editorDiv.root = editRoot;
    editorDiv.classList.remove(clsx(sectionsStyles.hiddenBlock));
    textValueDiv.classList.add(clsx(sectionsStyles.hiddenBlock));
    // отрисовка редактора
    editRoot.render(
      <Editor
        placeholder=" "
        styleInput={getStyleText({ TextStyle: record.dataset.textstyle })}
        disabled={record.dataset.locked === "1" ? true : false}
        groupid={record.dataset.groupid}
        current={record.dataset.current}
        fieldname={record.dataset.fieldname}
        name={record.dataset.name}
        type={record.dataset.module}
        record={record}
        objref={record.dataset.objref}
        value={record.dataset.editval}
        datatype={record.dataset.datatype}
        editStyle={record.dataset.editstyle}
        checkstate={record.dataset.checkstate}
        onEdit={onEdit}
        onEditButtonClick={onEditButtonClick}
        onDropDownList={onDropDownList}
        getEdition={setGetEdition}
        editParam={record.dataset.onedit}
        multisel={record.dataset.options & ParamSetOption_Detalization}
        selection={record.dataset.selection}
        editMask={record.dataset.editmask}
        // disabled={false}
        func={settingValues}
      />,
    );
    // }

    // отрисованный редактор
    editor.current = editorDiv;

    setTimeout(() => {
      // фокус на поле ввода
      const input = editorDiv.querySelector("input[type=text]");
      if (input) {
        input.focus();
        // проверка на readOnly
        if (record.dataset.editstyle & 64) return;
        input.select();
      } else {
        const textArea = editorDiv.querySelector("textarea");
        if (!textArea) return;
        textArea.focus();
        // проверка на readOnly
        if (record.dataset.editstyle & 64) return;
        textArea.select();
      }
    });
  }

  // функция скрытия редактора и отображения текста параметров
  function deleteEditor(editor) {
    if (!editor?.classList) return;
    if (!editor.classList.contains(clsx(sectionsStyles.hiddenBlock))) {
      const record = editor.closest("TR");
      record.style.backgroundColor = "";
      const textValueDiv = record.querySelector('[textvalue="true"]');
      editor.classList.add(clsx(sectionsStyles.hiddenBlock));
      textValueDiv.classList.remove(clsx(sectionsStyles.hiddenBlock));
    }
  }

  // функция на нажатие стрелок
  // проверяет следующий элемент на отображение и рисует в нем редактор
  function onKeyArrow(ev) {
    let record;
    switch (ev.key) {
      case "ArrowDown":
        record = ev.target.closest("TR").nextElementSibling;
        if (record) {
          if (record.classList.contains(clsx(sectionsStyles.hiddenBlock))) {
            while (record !== null) {
              record = record.nextElementSibling;
              if (record && !record.classList.contains(clsx(sectionsStyles.hiddenBlock))) {
                renderEditor({ target: record });
                break;
              }
            }
          } else {
            renderEditor({ target: record });
          }
        }

        break;
      case "ArrowUp":
        record = ev.target.closest("TR").previousElementSibling;
        if (record) {
          if (record.classList.contains(clsx(sectionsStyles.hiddenBlock))) {
            while (record !== null) {
              record = record.previousElementSibling;
              if (record && !record.classList.contains(clsx(sectionsStyles.hiddenBlock))) {
                renderEditor({ target: record });
                break;
              }
            }
          } else {
            renderEditor({ target: record });
          }
        }
        break;
      default:
        break;
    }
  }

  // функция установки размеров блока с кнопками
  function getButtonColWidth(options, other) {
    let res = 0;
    if (options & ParamSetOption_History) {
      res += 20;
    }
    if (other) {
      res += other.Conditions ? 20 : 0;
    }
    return res;
  }

  const historyButtonClick = (item, index) => {
    const paramsRequest = new Map();
    paramsRequest
      .set("prefix", "programs")
      .set("Path", props.Path ? props.Path : paramsData.Path)
      .set("ID", item.ID);
    smetaModals.open(
      <DialogHistory
        paramsRequest={paramsRequest}
        Module={item.Module}
        EditStyle={item.EditStyle}
        DataType={item.DataType}
        Options={item.Options}
        Values={item.Values}
        onSelect={(json) => {
          settingValues(
            { Values: [json.CheckState === undefined ? { ...json, CheckState: "0" } : json] },
            {
              record: paramsBox.current.querySelector(`#param_${item.ID}_${index}`),
            },
          );
        }}
      />,
      {
        Title: item.Name,
        style: getStyleWindow(),
        hiddenButton: true,
        blockMaximize: true,
        blockSaveLocation: true,
      },
    );
  };

  // Функция отрисовки записей для таблицы параметров
  function getJsxParams(items, width) {
    let colWidth;
    const returnArr = items.map((item, index) => {
      const expandButton = getExpandOrMarkButton(items, item, index);
      // условие для отрисовки чекбокса отдельно
      const editStyle = item.EditStyle & 4 ? item.EditStyle - 4 : item.EditStyle;

      colWidth = getButtonColWidth(item.Options, {
        Conditions: item.Conditions,
      });
      if (buttonBlockWidth < colWidth) {
        setbuttonBlockWidth(colWidth);
      }
      return (
        <tr
          // данные параметра хранятся внутри записи
          id={`param_${item.ID}_${index}`}
          key={`param-key_${item.ID}_${index}`}
          param-index={item.ID}
          data-datatype={item.DataType}
          data-editstyle={editStyle}
          data-fieldname={item.FieldName}
          data-name={item.Name}
          data-mapid={item.MapID}
          data-module={item.Module}
          data-options={item.Options}
          data-orderno={item.OrderNo}
          data-shortname={item.ShortName}
          data-level={item.Level ? item.Level : 0}
          data-parentid={item.ParentID}
          data-collapsed={(Number(item.Options) & ParamSetOption_Collapsed) === 32 ? "1" : "0"}
          data-value={item.Value}
          data-editval={item.EditVal !== undefined ? item.EditVal : item.Value}
          data-objref={item.ObjRef}
          data-groupid={paramsData.GroupID}
          data-current={item.Current}
          data-checkstate={item.CheckState}
          data-marked={"0"}
          data-locked={item.Locked}
          data-onedit={item.OnEdit}
          data-condition={item.Condition !== undefined ? item.Condition : item.Conditions ? "1" : undefined}
          data-textstyle={item.TextStyle}
          data-selection={item.Selection}
          data-editmask={item.EditMask}
          onClick={(ev) => {
            renderEditor(ev);
          }}
          onKeyDown={(ev) => {
            onKeyArrow(ev);
          }}
          onMouseEnter={(ev) => {
            if (mouseDown) {
              if (mouseDown.current) renderEditor(ev);
            }
          }}
          className={clsx(
            sectionsStyles.paramsRecord,
            ((item.Level && item.Level !== "0") ||
              Number(item.Options) & ParamSetOption_Disabled ||
              Number(item.Options) & ParamSetOption_Hidden) &&
              sectionsStyles.hiddenBlock,
          )}
        >
          {/* Имя параметра */}
          <td
            id={`name_${item.ID}`}
            title={item.Name}
            className={clsx(sectionsStyles.paramsName, "td-name")}
            style={{
              paddingLeft: getPadding(items, item, index),
              width: `${width.current}%`,
            }}
          >
            {expandButton}
            <span style={getStyleName(item)}>{item.Name}</span>
            {/* Колонка для кнопок история, выражение и тд */}
            <div
              className={clsx(sectionsStyles.paramsConditions)}
              style={{
                width: getButtonColWidth(item.Options, {
                  Conditions: item.Conditions,
                }),
              }}
            >
              <IconButton
                onClick={() => historyButtonClick(item, index)}
                className={clsx(
                  sectionsStyles.paramsHistoryButton,
                  (item.Options & ParamSetOption_History) === 0 && sectionsStyles.hiddenBlock,
                )}
              >
                <HistoryIcon style={{ height: "15px", width: "15px" }} />
              </IconButton>
              <ConditionButton
                visible={item.Conditions ? true : false}
                conditions={item.Conditions}
                condition={item.Condition ? item.Condition : "1"}
                onEdit={onEdit}
                recID={`param_${item.ID}_${index}`}
                paramsBoxRef={paramsBox}
              />
            </div>
          </td>
          {/* Разделитель */}
          <td onMouseDown={onMouseDown} className={clsx(sectionsStyles.paramsSplitter)} id="splitter-ID">
            <br></br>
          </td>
          {/* Значение параметра */}
          <td id={`value_${item.ID}`} className={sectionsStyles.paramsValueConteiner}>
            <div
              className={clsx(
                sectionsStyles.paramsCheckContainer,
                (item.EditStyle & 4) === 0 && sectionsStyles.hiddenBlock,
              )}
            >
              {/* чекбокс с множеством состояний */}
              <CheckBoxMultiCheck onEdit={onEdit} MultiCheckSet={item.MultiCheckSet} CheckState={item.CheckState} />
            </div>
            {/* текстовое значение параметра */}
            <div
              className={clsx(sectionsStyles.paramsValue)}
              style={{
                color: item.Value < 0 && item.Options & ParamSetOption_RedNegative ? "red" : getStyleColor(item),
                ...getStyleText(item),
              }}
              textvalue={"true"}
            >
              {item.Value}
            </div>

            {/* контейнер для редактора */}
            <div
              className={clsx(sectionsStyles.paramsEditorContainer, sectionsStyles.hiddenBlock)}
              editor={"true"}
            ></div>
          </td>
        </tr>
      );
    });

    return returnArr;
  }

  // функция для вызова истории
  async function historyClick(num) {
    const json = await getHistory({
      Path: props.Path ? props.Path : paramsData.Path,
      history: num,
    });
    // обновление параметров
    if (json) {
      // setEditorMap(new Map());
      // setEditionMap(new Map());
      setParamsJsx(null);
      deleteEditor(editor);
      setParamData({ ...json });
    }
  }

  async function ContextMenuHandler(data) {
    const comand = data.value;
    let json;
    switch (comand) {
      case "SelectSample":
        deleteEditor(editor);
        json = await HandleSamples({
          Path: props.Path ? props.Path : paramsData.Path,
          Command: "load",
          Name: data.name,
        });
        deleteEditor(editor);
        setParamsJsx(null);
        setParamData(json);

        break;
      case "DeleteSample":
        json = await HandleSamples({
          Path: props.Path ? props.Path : paramsData.Path,
          Command: "drop",
          Name: data.name,
        });
        if (json.Result === "1") {
          paramsData.Sample = undefined;
          deleteEditor(editor);
          setParamsJsx(null);
          setParamData({ ...paramsData });
        }
        break;
      case "SaveSample":
        CreateBackgroundForModal(
          <ModalWindow Title={"Сохранение шаблона параметров"} style={getStyleWindow("Sample")} hiddenButton={true}>
            <DialogSaveSample
              props={{
                Path: props.Path ? props.Path : paramsData.Path,
                value: paramsData.Sample,
              }}
            />
          </ModalWindow>,
        );
        break;
      case "ClearValues":
        json = await HandleSamples({
          Path: props.Path ? props.Path : paramsData.Path,
          Command: "reset",
          SectionID: props.SectionID,
        });
        deleteEditor(editor);
        setParamsJsx(null);
        setParamData({ ...json });
        break;
      case "FilterParams":
        setFilter(!filter);
        break;
      default:
        break;
    }
  }

  async function onMenuClick() {
    const params = {};
    const config = {
      prefix: Prefixes.progs,
      method: "POST",
      url: "HandleSamples",
      params,
      data: {
        Path: props.Path || paramsData.Path,
        Command: "list",
      },
    };
    const json = await smetaAxios(config);

    return { json: json, Sample: paramsData.Sample, filter: filter };
  }

  async function filterOnEdit(data) {
    let json = await HandleSamples({
      Path: props.Path ? props.Path : paramsData.Path,
      Command: "filter",
      Name: data.value,
    });
    setParamsJsx(null);
    setParamData({ ...json });
  }

  const dialogButtonClick = async (ev, Path, ProgID, callBack) => {
    const id = ev.currentTarget.id;
    const params = {
      Path: Path,
      ProgID: ProgID || "0",
      ID: Number(id) + 1,
      WSM: "1",
    };
    const config = {
      prefix: Prefixes.progs,
      method: "POST",
      url: "DialogButtonClick",
      params,
    };
    let json = await smetaAxios(config);
    if (json?.Token) {
      tokenProcessingTest(json, {
        func: (res) => {
          needRefreshParams(res);
        },
      });
    } else {
      if (id === "-1") {
        smetaModals.close(smetaModalId);
        await callBack();
        return;
      }

      needRefreshParams(json);
    }
  };

  const getParamsButtons = (buttons) => {
    return buttons.map((item, index) => {
      return (
        <Button
          onClick={(ev) => dialogButtonClick(ev, paramsData.Path)}
          id={item.id}
          key={`paramsButton-${index}`}
          variant="outlined"
          className={clsx(sectionsStyles.paramsSubButton)}
          style={{
            width: "120px",
          }}
        >
          {item?.Caption}
        </Button>
      );
    });
  };

  return (
    // при клике вне контейнера параметров редактор скроется
    <ContextMenu
      for={"params"}
      Menu={getDefaultMenu("HandleParams", {
        NoClearState: props.NoClearState ? true : false,
        NoSaveSample: props.NoSaveSample ? true : false,
      })}
      onRightClick={onMenuClick}
      onMenuItemClick={ContextMenuHandler}
    >
      <ClickAwayListener
        onClickAway={(ev) => {
          mouseDown.current = false;
          resize = {};
          if (!editor.current || editor.current.classList.contains(clsx(sectionsStyles.hiddenBlock))) {
            return;
          }

          if (
            ev.target.closest("[checklist]") ||
            ev.target.closest("[calendar]") ||
            (ev.target.closest(".background_ModalDialog") &&
              ev.target.closest(".background_ModalDialog") !== paramsBox.current.closest(".background_ModalDialog")) ||
            ev.target.closest("LI") ||
            ev.target.classList.contains("MuiBackdrop-root") ||
            ev.target.closest("#applyButton")
          ) {
            return;
          }
          if (editor.current) {
            editor.current.closest("TR").style.backgroundColor = "";
            deleteEditor(editor.current);
          }
        }}
      >
        <div
          id={"paramsBox"}
          ref={paramsBox}
          onMouseDown={(ev) => {
            mouseDown.current = true;
          }}
          onMouseUp={() => {
            mouseDown.current = false;
          }}
          className={clsx(sectionsStyles.paramsBox)}
        >
          {loading && (
            <div className={sectionsStyles.paramsLoadingMask}>
              <LoadingMask />
            </div>
          )}
          <Scrollbars
            autoHide
            className={clsx(sectionsStyles.paramsTitleScroll, props.NoTitle && sectionsStyles.hiddenBlock)}
          >
            <div className={clsx(sectionsStyles.paramsTitleContainer, props.NoTitle && sectionsStyles.hiddenBlock)}>
              <div className={clsx(sectionsStyles.paramsTitle)}>{title}</div>
            </div>
          </Scrollbars>
          <div className={clsx(sectionsStyles.paramsFilter, !filter && sectionsStyles.hiddenBlock)}>
            <div className={clsx(sectionsStyles.paramsFilterLabel)}>Фильтр:</div>
            <div className={clsx(sectionsStyles.paramsFilterInput)}>
              <Editor
                value={paramsData && paramsData.Filter ? paramsData.Filter : ""}
                onEdit={filterOnEdit}
                placeholder=""
              />
            </div>
          </div>
          {/* контейнер с таблицей параметров */}
          <div style={{ display: "flex", flexDirection: "row", flex: "1 1 auto" }}>
            <Scrollbars autoHide>
              {paramsJsx ? (
                <div
                  onMouseMove={onMouseMove}
                  onMouseUp={(ev) => onMouseUp(ev, width)}
                  className={clsx(sectionsStyles.paramsTable)}
                >
                  <tbody>{paramsJsx}</tbody>
                </div>
              ) : (
                <LoadingMask />
              )}
            </Scrollbars>
            {paramsJsx && (
              <div className={clsx(sectionsStyles.paramsButtonsContainer)}>
                {paramsButtonsJsx?.length > 0 && paramsButtonsJsx}
              </div>
            )}
          </div>
          {/* контейнер для кнопок истории */}
          <div className={clsx(sectionsStyles.paramsListHistoryButtons, !history && sectionsStyles.hiddenBlock)}>
            <IconButton
              disabled={history === "2"}
              onClick={() => {
                historyClick(-1);
              }}
              className={clsx(sectionsStyles.paramsListHistoryButton)}
            >
              <KeyboardDoubleArrowLeftIcon />
            </IconButton>
            <div className={clsx(sectionsStyles.flexContaner)}></div>
            <IconButton
              disabled={history === "1"}
              onClick={() => {
                historyClick(1);
              }}
              className={clsx(sectionsStyles.paramsListHistoryButton)}
            >
              <KeyboardDoubleArrowRightIcon />
            </IconButton>
          </div>
        </div>
      </ClickAwayListener>
    </ContextMenu>
  );
}
